import { Component, computed, Input, OnInit, signal, Signal, ViewChild, WritableSignal } from '@angular/core';
import { IonContent, ModalController } from '@ionic/angular';
import { Place } from 'src/app/interfaces/interfaces';
import { PlacesStore } from 'src/app/stores/places.store';

@Component({
  selector: 'app-add-resource',
  templateUrl: './add-resource.component.html',
  styleUrls: ['./add-resource.component.scss'],
})
export class AddResourceComponent implements OnInit {
  @Input() initialResources: Place[] = [];
  @Input() startTime: string;
  @Input() endTime: string;
  @ViewChild('contentRef', { read: IonContent }) content!: IonContent;

  addedResources: WritableSignal<Place[]> = signal<Place[]>([]);
  searchTerm: WritableSignal<string> = signal('');
  resourcesList: Signal<Place[]> = computed(() =>
    this.placesStore.places().filter(
      (place) =>
        !this.addedResources().find((r) => r.emailAddress === place.emailAddress) &&
        this.placesStore.findMatchingPlaces(place, this.searchTerm())
    )
  );

  constructor(private modalController: ModalController, private placesStore: PlacesStore) {}

  ngOnInit() {
    this.addedResources.set(this.initialResources);
  }

  async selectResource(resource: Place) {
    resource.isLoading = true;
    try {
      const res = await this.placesStore.fetchOnePlaceAvailability(
        new Date(this.startTime),
        new Date(this.endTime),
        null,
        null,
        null,
        resource
      );
      resource.isAvailable = res;
      resource.isLoading = false;
      this.addedResources.update((resources) => [...resources, resource]);
    } catch (error) {
      resource.isLoading = false;
      console.error(error);
    }
    this.content.scrollToTop(1000);
  }

  removeResource(resource: Place) {
    this.addedResources.update((resources) =>
      resources.filter((r) => r.emailAddress !== resource.emailAddress)
    );
  }

  filterResources(event) {
    this.searchTerm.set(event.target.value);
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  onDone() {
    this.modalController.dismiss(this.addedResources());
  }
}
